export default __webpack_public_path__ + "static/media/yelpCampPic.eb01c3d8.png";